/** @jsx h */
/* eslint camelcase: ["error", {ignoreDestructuring: true}] */
import { h } from 'preact'
import { format } from 'date-fns'
import { de } from 'date-fns/locale'
import cls from 'classnames'

const DATE_FORMAT = 'dd.MM.yy'

const VenueIcon = ({
  type,
  next_dates: nextDates,
  appointments_count: appointmentsCount,
  active
}) => {
  return (
    <ol class={cls('appointment-search__venue-marker', {
      '--active': active,
      '--center': type === 'center',
      '--mobile': type === 'mobile'
    })}>
      {nextDates.map(date => (
        <li>{format(new Date(date), DATE_FORMAT, { locale: de })}</li>
      ))}
      {appointmentsCount > 3 && <li class="dotsmore">...</li>}
    </ol>
  )
}

export default VenueIcon
